import generateMetaInfo from './generateMetaInfo'
import generateMetaTitle from './generateMetaTitle'
import generateMetaImage from './generateMetaImage'

export {
  generateMetaTitle,
  generateMetaInfo,
  generateMetaImage
}



// WEBPACK FOOTER //
// ./client/common/index.js